export default __webpack_public_path__ + "static/media/milestone 3600.e8f7cb8f.svg";